export default {"src":"/education/_next/static/media/arrow-right-white.8ba20e95.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};